import PropTypes from 'prop-types';
import React from 'react';
import { Dialog, CardActions } from 'react-toolbox';
import { confirmable } from 'react-confirm';
import ColoredButton from 'components/ColoredButton';
import MessageBox from 'components/MessageBox';
import styles from 'styles/form.scss';
import cx from 'classnames';

const cancelClass = cx([styles.cancelButton, styles.actionButton]);
const cardActionsClass = cx([styles.actionsWrapper, styles.rightDown]);

const ConfirmDialog = ({ show, proceed, dismiss, cancel, confirmation, error, ...options }) => {
  const { title, theActions } = options;
  const actions = theActions || ['Cancel', 'OK'];
  return (
    <Dialog
      active={show}
      onEscKeyDown={dismiss}
      onOverlayClick={dismiss}
      title={title || 'Delete confirmation'}
    >
      {confirmation}
      {error && <MessageBox message={error} error />}
      <CardActions className={cardActionsClass}>
        {actions.indexOf('Cancel') > -1 ?
          <ColoredButton
            className={cancelClass}
            responsive
            color={options.cancelColor}
            label={options.cancelLabel}
            onClick={cancel}
          /> : null
        }
        {actions.indexOf('OK') > -1 ?
          <ColoredButton
            className={styles.actionButton}
            responsive
            color={options.okColor}
            label={options.okLabel}
            onClick={proceed}
          /> : null
        }
      </CardActions>
    </Dialog>);
};

ConfirmDialog.defaultProps = { okLabel: 'OK', cancelLabel: 'Cancel', okColor: 'green', cancelColor: 'gray' };

ConfirmDialog.propTypes = {
  show: PropTypes.bool,
  proceed: PropTypes.func,
  dismiss: PropTypes.func,
  cancel: PropTypes.func,
  confirmation: PropTypes.node,
  title: PropTypes.string,
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  okColor: PropTypes.string,
  cancelColor: PropTypes.string,
  error: PropTypes.string,
};

export default confirmable(ConfirmDialog);



// WEBPACK FOOTER //
// ./client/app/shared/components/ConfirmDialog/index.jsx